// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__EGS3G","container":"styles_container__m5m7N"};